export default ['390px', '768px', '1024px']
